/* eslint-disable */
export default {
  _Orbitron: 'Orbitron',
  _Asap: 'Asap',
  _BPreplay: 'BPreplay',
  _BPreplayBold: 'BPreplayBold',
  _Barlow: 'Barlow',
  _Audiowide: 'Audiowide',
  _Bebas_Neue: 'Bebas Neue',
  _Komika: 'Komika',
  _Rokkitt: 'Rokkitt',
  _Munson: 'Munson',
  _Roboto: 'Roboto',
  _Patrick_Hand: 'Patrick Hand',
  _Teko: 'Teko',
}